export class TypeCoord {

  public mel: string;

  public tel: string;

  public poste: string;

  public fax: string;

  public url: string;

  constructor() {
    this.mel = '';
    this.tel = '';
    this.poste = '';
    this.fax = '';
    this.url = '';

  }
}
